/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronic.de | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function initReferralHero(sectionId) {
  var $section = $('#referral-hero-' + sectionId);
  if (!$section.length) return;

  var $srElements = $section.find('.sr-hidden');

  function showInstantly($elements) {
    $elements.each(function() {
      if (typeof ScrollReveal !== 'undefined') ScrollReveal().clean(this);
      $(this).css({ visibility: 'visible', opacity: 1, transform: 'none' });
    });
  }

  if (window.innerWidth > 799 && typeof ScrollReveal !== 'undefined') {
    $srElements.each(function(i, el) {
      ScrollReveal().reveal(el, {
        origin: 'bottom',
        distance: '20px',
        duration: 700,
        delay: 40 + (i * 40),
        easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
        opacity: 0,
        scale: 1,
        once: true
      });
    });
  } else {
    showInstantly($srElements);
  }

  var $popup = $('#referral-hero-popup-' + sectionId);
  if (!$popup.length) return;

  var $openTriggers = $section.find('[data-referral-popup-open]');
  var $closeTriggers = $popup.find('[data-referral-popup-close]');

  function openPopup() {
    $popup.addClass('is-open').attr('aria-hidden', 'false');
    $('body').addClass('referral-hero-popup-open');
    if (typeof window.lenis !== 'undefined' && window.lenis && window.lenis.stop) {
      window.lenis.stop();
    }
  }

  function closePopup() {
    $popup.removeClass('is-open').attr('aria-hidden', 'true');
    $('body').removeClass('referral-hero-popup-open');
    if (typeof window.lenis !== 'undefined' && window.lenis && window.lenis.start) {
      window.lenis.start();
    }
  }

  $openTriggers.on('click', function(e) {
    e.preventDefault();
    openPopup();
  });

  $closeTriggers.on('click', function(e) {
    e.preventDefault();
    closePopup();
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $popup.hasClass('is-open')) {
      closePopup();
    }
  });
}

$(function() {
  var instances = window.DeskReferralHero || {};
  $.each(instances, function(id) {
    initReferralHero(id);
  });
});